import React from 'react'
import validator from 'validator'
import _ from 'lodash'
import queryString from 'query-string'

import {
    TextField, Checkbox, Button, FormGroup,
    FormControl, FormHelperText, FormControlLabel,
    MenuItem, AppBar, Tab, Tabs, Typography,
    withStyles, Grid
} from 'material-ui'
import {Facebook, Email} from 'mdi-material-ui';

import API from '../api'

const styles = theme => ({
    root: {

    },
    buttonBar: {
        display: 'flex',
        justifyContent: 'center',
        padding: 10,
    },
    button: {

    },
    hidden: {
        display: 'none',
        backgroundColor: "rgba(0,0,0,0.1)"
    },
})

class FBSignupButton extends React.Component {
    handleClick = () => {
        console.log('clicking')
        try {
            this.props.onValidate()
            this.props.onClick(this)
        } catch(e) {
            console.error('Form had errors', e)
        }
    }
    render() {
        return (
            <Button raised color="primary" onClick={this.handleClick}>
                <Facebook/> Sign up with Facebook
            </Button>
        )
    }
}

const TosPrivacyLabel = () => (
    <span>
        I have read and agree to the &nbsp;
        <a href="https://app.carefol.io/legal/tos" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        &nbsp; and &nbsp;
        <a href="https://app.carefol.io/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </span>
)

const TosSubscribeBlock = ({values, errors, onChange}) => (
    <div>
        <FormGroup>
            <br/>
            <FormControl error={errors.accept_tos && true}>
                <FormControlLabel
                    label={<TosPrivacyLabel />}
                    control={
                        <Checkbox name="accept_tos" value={values.accept_tos} onChange={onChange}/>
                    }
                />
                {errors.accept_tos && <FormHelperText>{errors.accept_tos}</FormHelperText>}
            </FormControl>
        </FormGroup>
        <FormGroup>
            <FormControlLabel
                label="Sign me up for the monthly newsletter"
                control={
                    <Checkbox name="subscribe" value={values.subscribe} onChange={onChange}/>
                }
            />
        </FormGroup>
    </div>
)

class EmailLoginForm extends React.Component {

    constructor(...args) {
        super(...args)
        this.state = {
            values: {
                name: '',
                email: '',
                accept_tos: false,
                subscribe: false,
            },
            errors: {}
        }
    }

    handleChange = (e, value) => {
        console.log('Setting value', e.target.name, e.target.value, value)
        this.setState({
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSubmit = async() => {
        let errors = {}
        let values = {
            ...this.state.values,
            name: validator.trim(this.state.values.name),
            email: validator.trim(this.state.values.email),
        }
        if(validator.isEmpty(values.name)) {
            errors['name'] = 'Please enter your name'
        }
        if(!validator.isEmail(values.email)) {
            errors['email'] = 'Please enter a valid email address'
        }
        if(!values.accept_tos) {
            errors['accept_tos'] = 'You must accept the terms of service and privacy policy to create an account'
        }
        this.setState({errors})
        if (!_.isEmpty(errors)) {
            console.log('Errors: ', errors)
            return
        }
        try {
            let link_path = `${process.env.REACT_APP_ROOT}/public/confirmRegistration`
            let credentials = {
                grant_type: 'https://sso.ehtcares.com/register',
                email: values.email,
                name: values.name,
                link_path
            }
            const resp = await API.post(API.href('token'), credentials)
            this.props.history.push('/signup-thanks')
            return false
        } catch(err) {
            console.error(err);
            alert('Unexpected error, please send an email to support@carefol.io to sign up')
        }
    }

    render() {
        const {values, errors} = this.state
        const {classes} = this.props
        return (
            <div>
                <TextField
                    fullWidth label="Your name" name="name"
                    error={errors.name && true} helperText={errors.name}
                    value={values.name} onChange={this.handleChange}/>
                <TextField
                    fullWidth label="Your email" name="email"
                    error={errors.email && true} helperText={errors.email}
                    value={values.email} onChange={this.handleChange}/>
                <TosSubscribeBlock values={values} errors={errors} onChange={this.handleChange}/>
                <div className={classes.buttonBar}>
                    <Button className={classes.button} raised color="primary" onClick={this.handleSubmit}>
                        Sign me up
                    </Button>
                </div>
            </div>
        )
    }
}

class FBLoginForm extends React.Component {

    constructor(...args) {
        super(...args)
        this.state = {
            values: {
                accept_tos: false,
                subscribe: false,
            },
            errors: {}
        }
    }

    handleChange = (e, value) => {
        this.setState({
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSubmit = () => {
        const {values} = this.state
        let errors = {}
        if(!values.accept_tos) {
            errors['accept_tos'] = 'You must accept the terms of service and privacy policy to create an account'
        }
        console.log('Values, errors is', values, errors)
        this.setState({errors})
        if (!_.isEmpty(errors)) {
            console.log('Errors: ', errors)
            return
        }
        window.location = API.href('facebookLaunch')
    }

    render() {
        const {values, errors} = this.state
        const {classes} = this.props
        return (
            <div>
                <TosSubscribeBlock values={values} errors={errors} onChange={this.handleChange}/>
                <div className={classes.buttonBar}>
                    <Button raised color="primary" onClick={this.handleSubmit}>
                        <Facebook/> Sign up with Facebook
                    </Button>
                </div>
            </div>
        )
    }
}


class SignupForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {classes, history} = this.props
        return (
            <div className={classes.root}>
                <EmailLoginForm classes={classes} history={history}/>
                <br/>
                <Typography component="p" align="center">
                    Already have an account?
                </Typography>
                <Typography component="p" align="center">
                    <a href={API.loginHref()}>Sign in</a>
                </Typography>
            </div>
        )
    }
}

const NameEmail = ({errors, values, onChange}) => (
    <div>
        <TextField
            fullWidth label="Your name" name="name"
            error={errors.name && true} helperText={errors.name}
            value={values.name} onChange={onChange}/>
        <TextField
            fullWidth label="Your email" name="email"
            error={errors.email && true} helperText={errors.email}
            value={values.email} onChange={onChange}/>
    </div>
)


export default withStyles(styles)(SignupForm)


// WEBPACK FOOTER //
// ./src/components/SignupForm.jsx